/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "decʼh",
        "-2": "dercʼhent-decʼh",
        "0": "hiziv",
        "1": "warcʼhoazh",
        "future": {
          "few": "a-benn {0} deiz",
          "many": "a-benn {0} a zeizioù",
          "one": "a-benn {0} deiz",
          "other": "a-benn {0} deiz",
          "two": "a-benn {0} zeiz"
        },
        "past": {
          "few": "{0} deiz zo",
          "many": "{0} a zeizioù zo",
          "one": "{0} deiz zo",
          "other": "{0} deiz zo",
          "two": "{0} zeiz zo"
        }
      },
      "day-narrow": {
        "-1": "decʼh",
        "-2": "dercʼhent-decʼh",
        "0": "hiziv",
        "1": "warcʼhoazh",
        "future": {
          "few": "+{0} d",
          "many": "+{0} d",
          "one": "+{0} d",
          "other": "+{0} d",
          "two": "+{0} d"
        },
        "past": {
          "few": "-{0} d",
          "many": "-{0} d",
          "one": "-{0} d",
          "other": "-{0} d",
          "two": "-{0} d"
        }
      },
      "day-short": {
        "-1": "decʼh",
        "-2": "dercʼhent-decʼh",
        "0": "hiziv",
        "1": "warcʼhoazh",
        "future": {
          "few": "a-benn {0} d",
          "many": "a-benn {0} d",
          "one": "a-benn {0} d",
          "other": "a-benn {0} d",
          "two": "a-benn {0} d"
        },
        "past": {
          "few": "{0} d zo",
          "many": "{0} d zo",
          "one": "{0} d zo",
          "other": "{0} d zo",
          "two": "{0} d zo"
        }
      },
      "hour": {
        "0": "dʼan eur-mañ",
        "future": {
          "few": "a-benn {0} eur",
          "many": "a-benn {0} a eurioù",
          "one": "a-benn {0} eur",
          "other": "a-benn {0} eur",
          "two": "a-benn {0} eur"
        },
        "past": {
          "few": "{0} eur zo",
          "many": "{0} a eurioù zo",
          "one": "{0} eur zo",
          "other": "{0} eur zo",
          "two": "{0} eur zo"
        }
      },
      "hour-narrow": {
        "0": "dʼan eur-mañ",
        "future": {
          "few": "+{0} h",
          "many": "+{0} h",
          "one": "+{0} h",
          "other": "+{0} h",
          "two": "+{0} h"
        },
        "past": {
          "few": "-{0} h",
          "many": "-{0} h",
          "one": "-{0} h",
          "other": "-{0} h",
          "two": "-{0} h"
        }
      },
      "hour-short": {
        "0": "dʼan eur-mañ",
        "future": {
          "few": "a-benn {0} e",
          "many": "a-benn {0} e",
          "one": "a-benn {0} e",
          "other": "a-benn {0} e",
          "two": "a-benn {0} e"
        },
        "past": {
          "few": "{0} e zo",
          "many": "{0} e zo",
          "one": "{0} e zo",
          "other": "{0} e zo",
          "two": "{0} e zo"
        }
      },
      "minute": {
        "0": "ar munut-mañ",
        "future": {
          "few": "a-benn {0} munut",
          "many": "a-benn {0} a vunutoù",
          "one": "a-benn {0} munut",
          "other": "a-benn {0} munut",
          "two": "a-benn {0} vunut"
        },
        "past": {
          "few": "{0} munut zo",
          "many": "{0} a vunutoù zo",
          "one": "{0} munut zo",
          "other": "{0} munut zo",
          "two": "{0} vunut zo"
        }
      },
      "minute-narrow": {
        "0": "ar munut-mañ",
        "future": {
          "few": "+{0} min",
          "many": "+{0} min",
          "one": "+{0} min",
          "other": "+{0} min",
          "two": "+{0} min"
        },
        "past": {
          "few": "-{0} min",
          "many": "-{0} min",
          "one": "-{0} min",
          "other": "-{0} min",
          "two": "-{0} min"
        }
      },
      "minute-short": {
        "0": "ar munut-mañ",
        "future": {
          "few": "a-benn {0} min",
          "many": "a-benn {0} min",
          "one": "a-benn {0} min",
          "other": "a-benn {0} min",
          "two": "a-benn {0} min"
        },
        "past": {
          "few": "{0} min zo",
          "many": "{0} min zo",
          "one": "{0} min zo",
          "other": "{0} min zo",
          "two": "{0} min zo"
        }
      },
      "month": {
        "-1": "ar miz diaraok",
        "0": "ar miz-mañ",
        "1": "ar miz a zeu",
        "future": {
          "few": "a-benn {0} miz",
          "many": "a-benn {0} a vizioù",
          "one": "a-benn {0} miz",
          "other": "a-benn {0} miz",
          "two": "a-benn {0} viz"
        },
        "past": {
          "few": "{0} miz zo",
          "many": "{0} a vizioù zo",
          "one": "{0} miz zo",
          "other": "{0} miz zo",
          "two": "{0} viz zo"
        }
      },
      "month-narrow": {
        "-1": "ar m. diaraok",
        "0": "ar m.-mañ",
        "1": "ar m. a zeu",
        "future": {
          "few": "+{0} miz",
          "many": "+{0} miz",
          "one": "+{0} miz",
          "other": "+{0} miz",
          "two": "+{0} miz"
        },
        "past": {
          "few": "-{0} miz",
          "many": "-{0} miz",
          "one": "-{0} miz",
          "other": "-{0} miz",
          "two": "-{0} miz"
        }
      },
      "month-short": {
        "-1": "ar miz diaraok",
        "0": "ar miz-mañ",
        "1": "ar miz a zeu",
        "future": {
          "few": "a-benn {0} miz",
          "many": "a-benn {0} a vizioù",
          "one": "a-benn {0} miz",
          "other": "a-benn {0} miz",
          "two": "a-benn {0} viz"
        },
        "past": {
          "few": "{0} miz zo",
          "many": "{0} a vizioù zo",
          "one": "{0} miz zo",
          "other": "{0} miz zo",
          "two": "{0} viz zo"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "an trimiziad diaraok",
        "0": "an trimiziad-mañ",
        "1": "an trimiziad a zeu",
        "future": {
          "few": "a-benn {0} zrimiziad",
          "many": "a-benn {0} a drimiziadoù",
          "one": "a-benn {0} trimiziad",
          "other": "a-benn {0} trimiziad",
          "two": "a-benn {0} drimiziad"
        },
        "past": {
          "few": "{0} zrimiziad zo",
          "many": "{0} a zrimiziadoù zo",
          "one": "{0} trimiziad zo",
          "other": "{0} trimiziad zo",
          "two": "{0} drimiziad zo"
        }
      },
      "quarter-narrow": {
        "-1": "an trim. diaraok",
        "0": "an trim.-mañ",
        "1": "an trim. a zeu",
        "future": {
          "few": "+{0} trim.",
          "many": "+{0} trim.",
          "one": "+{0} trim.",
          "other": "+{0} trim.",
          "two": "+{0} trim."
        },
        "past": {
          "few": "-{0} trim.",
          "many": "-{0} trim.",
          "one": "-{0} trim.",
          "other": "-{0} trim.",
          "two": "-{0} trim."
        }
      },
      "quarter-short": {
        "-1": "an trim. diaraok",
        "0": "an trim.-mañ",
        "1": "an trim. a zeu",
        "future": {
          "few": "a-benn {0} trim.",
          "many": "a-benn {0} trim.",
          "one": "a-benn {0} trim.",
          "other": "a-benn {0} trim.",
          "two": "a-benn {0} trim."
        },
        "past": {
          "few": "{0} trim. zo",
          "many": "{0} trim. zo",
          "one": "{0} trim. zo",
          "other": "{0} trim. zo",
          "two": "{0} trim. zo"
        }
      },
      "second": {
        "0": "bremañ",
        "future": {
          "few": "a-benn {0} eilenn",
          "many": "a-benn {0} a eilennoù",
          "one": "a-benn {0} eilenn",
          "other": "a-benn {0} eilenn",
          "two": "a-benn {0} eilenn"
        },
        "past": {
          "few": "{0} eilenn zo",
          "many": "{0} eilenn zo",
          "one": "{0} eilenn zo",
          "other": "{0} eilenn zo",
          "two": "{0} eilenn zo"
        }
      },
      "second-narrow": {
        "0": "brem.",
        "future": {
          "few": "+{0} s",
          "many": "+{0} s",
          "one": "+{0} s",
          "other": "+{0} s",
          "two": "+{0} s"
        },
        "past": {
          "few": "-{0} s",
          "many": "-{0} s",
          "one": "-{0} s",
          "other": "-{0} s",
          "two": "-{0} s"
        }
      },
      "second-short": {
        "0": "brem.",
        "future": {
          "few": "a-benn {0} s",
          "many": "a-benn {0} s",
          "one": "a-benn {0} s",
          "other": "a-benn {0} s",
          "two": "a-benn {0} s"
        },
        "past": {
          "few": "{0} s zo",
          "many": "{0} s zo",
          "one": "{0} s zo",
          "other": "{0} s zo",
          "two": "{0} s zo"
        }
      },
      "week": {
        "-1": "ar sizhun diaraok",
        "0": "ar sizhun-mañ",
        "1": "ar sizhun a zeu",
        "future": {
          "few": "a-benn {0} sizhun",
          "many": "a-benn {0} a sizhunioù",
          "one": "a-benn {0} sizhun",
          "other": "a-benn {0} sizhun",
          "two": "a-benn {0} sizhun"
        },
        "past": {
          "few": "{0} sizhun zo",
          "many": "{0} a sizhunioù zo",
          "one": "{0} sizhun zo",
          "other": "{0} sizhun zo",
          "two": "{0} sizhun zo"
        }
      },
      "week-narrow": {
        "-1": "ar sizh. diaraok",
        "0": "ar sizh.-mañ",
        "1": "ar sizh. a zeu",
        "future": {
          "few": "a-benn {0} sizh.",
          "many": "a-benn {0} sizh.",
          "one": "a-benn {0} sizh.",
          "other": "a-benn {0} sizh.",
          "two": "a-benn {0} sizh."
        },
        "past": {
          "few": "{0} sizh. zo",
          "many": "{0} sizh. zo",
          "one": "{0} sizh. zo",
          "other": "{0} sizh. zo",
          "two": "{0} sizh. zo"
        }
      },
      "week-short": {
        "-1": "ar sizh. diaraok",
        "0": "ar sizh.-mañ",
        "1": "ar sizh. a zeu",
        "future": {
          "few": "a-benn {0} sizh.",
          "many": "a-benn {0} sizh.",
          "one": "a-benn {0} sizh.",
          "other": "a-benn {0} sizh.",
          "two": "a-benn {0} sizh."
        },
        "past": {
          "few": "{0} sizh. zo",
          "many": "{0} sizh. zo",
          "one": "{0} sizh. zo",
          "other": "{0} sizh. zo",
          "two": "{0} sizh. zo"
        }
      },
      "year": {
        "-1": "warlene",
        "0": "hevlene",
        "1": "ar bloaz a zeu",
        "future": {
          "few": "a-benn {0} bloaz",
          "many": "a-benn {0} a vloazioù",
          "one": "a-benn {0} bloaz",
          "other": "a-benn {0} vloaz",
          "two": "a-benn {0} vloaz"
        },
        "past": {
          "few": "{0} bloaz zo",
          "many": "{0} a vloazioù zo",
          "one": "{0} bloaz zo",
          "other": "{0} vloaz zo",
          "two": "{0} vloaz zo"
        }
      },
      "year-narrow": {
        "-1": "warlene",
        "0": "hevlene",
        "1": "ar bl. a zeu",
        "future": {
          "few": "+{0} bl.",
          "many": "+{0} bl.",
          "one": "+{0} bl.",
          "other": "+{0} bl.",
          "two": "+{0} bl."
        },
        "past": {
          "few": "-{0} bl.",
          "many": "-{0} bl.",
          "one": "-{0} bl.",
          "other": "-{0} bl.",
          "two": "-{0} bl."
        }
      },
      "year-short": {
        "-1": "warlene",
        "0": "hevlene",
        "1": "ar bl. a zeu",
        "future": {
          "few": "a-benn {0} bl.",
          "many": "a-benn {0} bl.",
          "one": "a-benn {0} bl.",
          "other": "a-benn {0} bl.",
          "two": "a-benn {0} bl."
        },
        "past": {
          "few": "{0} bl. zo",
          "many": "{0} bl. zo",
          "one": "{0} bl. zo",
          "other": "{0} bl. zo",
          "two": "{0} bl. zo"
        }
      }
    },
    "locale": "br"
  });
}